import { attr, html, TNode } from '@tempots/dom'

export function Highlight(...children: TNode[]) {
  return html.span(
    attr.class('text-primary font-semibold text-teal-800'),
    ...children
  )
}
